import { convertDateFields } from './ls-date-field-converter';
import { copyProps } from './object-property-copier';

export interface Newable<M> {
    new(...params: any[]): M;
}

export class LSModelFactory<M> extends Object {

    private _modelCtor: Newable<M>;

    get modelCtor(): Newable<M> {
        return this._modelCtor;
    }

    constructor(modelCtor: Newable<M>) {
        super();
        this._modelCtor = modelCtor;
    }

    fromJson(json: any): M {
        const model = new this.modelCtor();
        copyProps(model as Object, json);
        convertDateFields(model as Object);
        return model;
    }
}
